import { Component } from '@angular/core';

@Component({
  selector: 'nrk-header',
  templateUrl: './nrk-header.component.html',
  styleUrls: ['./nrk-header.component.scss']
})
export class NrkHeaderComponent {

}
